const statusObjeto = [
	{ nome: 'Finalizado', status: 1 },
	{ nome: 'Pendente', status: 2 },
	{ nome: 'Preenchimento pendente', status: 3, filterOnly: true }
]

export default statusObjeto
